module.exports = __webpack_public_path__ + "img/valeur-stock.4c62cc48.png";